import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'
//
import global from 'common'

import updateBillingEmail from 'core/application/adminDashboard/companySettings/subscription/billingEmail'

import Tooltip from 'common/components/dataDisplay/Tooltip'
import notification from 'common/components/feedback/Notification'
import Button from 'common/components/general/Button'
import Icon from 'common/components/general/Icon'

import { commandRequest } from 'common/RequestUtils'

import SubscriptionDetail from '../components/SubscriptionDetail'
import BillingInformationForm, { BillingInformationValues } from './BillingInformationForm'

interface BillingInformationProps {
  billingEmail: string
  onBillingInfoSave: () => void
}

const BillingInformation: React.FC<BillingInformationProps> = ({ billingEmail, onBillingInfoSave }) => {
  const { t: translate } = useTranslation()
  const { isXs } = global.hooks.useBreakPoints()

  const [editMode, setEditMode] = useState<boolean>(false)

  const onSave = async (values: BillingInformationValues) => {
    const result = await commandRequest(() => updateBillingEmail(values))

    if (result.errors) {
      notification.open({
        message: translate('admin-signup.subscription.errors.went-wrong-message'),
        description: translate('admin-signup.subscription.errors.connection-error'),
        type: 'error',
      })

      return
    }
    setEditMode(false)
    onBillingInfoSave()
  }

  return (
    <div>
      <div>
        <h6>{translate('admin-dashboard.company-settings.subscription.billing-information')}</h6>
      </div>

      {editMode ? (
        <BillingInformationForm onCancel={() => setEditMode(false)} onSave={onSave} />
      ) : (
        <Row>
          <Col xs={24} sm={20}>
            <SubscriptionDetail
              title={
                <div className="flex">
                  <p className="mr-8">{translate('admin-dashboard.company-settings.subscription.billing-email')}</p>
                  <Tooltip title={translate('admin-dashboard.company-settings.subscription.billing-email-tooltip')}>
                    <Icon type="far fa-info-circle" className="color-blue-6" fontAwesome /> {` `}
                  </Tooltip>
                </div>
              }
              description={billingEmail}
            />
          </Col>
          <Col xs={24} sm={4} className={`flex ${isXs ? 'mb-16' : 'justify-end align-end mb-16'}`}>
            <Button type="primary" icon={'far fa-pen'} onClick={() => setEditMode(true)}>
              {translate('general.edit')}
            </Button>
          </Col>
        </Row>
      )}
    </div>
  )
}

export default BillingInformation
